import _ from 'lodash';
import * as AgreementsAPI from '../../repository/jago/agreementsAPI';
import { IState } from '../store';
import { ActionsUnion, createAction, IThunkAction } from '../utils';
import AgreementsActionTypesEnum from './model/AgreementsActionTypesEnum';

export const AgreementsActions = {
  saveAgreements: createAction<typeof AgreementsActionTypesEnum.SAVE_AGREEMENTS, any[]>(AgreementsActionTypesEnum.SAVE_AGREEMENTS),
  saveAcceptedAgreements: createAction<typeof AgreementsActionTypesEnum.SAVE_ACCEPTED_AGREEMENTS, any[]>(AgreementsActionTypesEnum.SAVE_ACCEPTED_AGREEMENTS),
  setAgreementFilter: createAction<typeof AgreementsActionTypesEnum.SET_AGREEMENT_FILTER, { field: string; value: any }>(AgreementsActionTypesEnum.SET_AGREEMENT_FILTER),
  resetAgreementFilters: createAction<typeof AgreementsActionTypesEnum.RESET_AGREEMENT_FILTERS, void>(AgreementsActionTypesEnum.RESET_AGREEMENT_FILTERS),
  resetAgreements: createAction<typeof AgreementsActionTypesEnum.RESET_AGREEMENTS, void>(AgreementsActionTypesEnum.RESET_AGREEMENTS),
};

export type AgreementsActionsType = ActionsUnion<typeof AgreementsActions>;

export function fetchLatestAgreements(params?: any): IThunkAction<Promise<any[]>, IState> {
  return async (dispatch, getState) => {
    const { filters } = getState().agreements;
    const formattedParams = {
      ...filters,
      ...params,
    };
    try {
      const response = await AgreementsAPI.fetchLatestAgreements(formattedParams);
      if (response.data) {
        dispatch(AgreementsActions.saveAgreements(response.data));
        return response.data;
      }
      throw new Error();
    } catch (error) {
      throw new Error(error as string);
    }
  };
}

export function checkUpdatedAgreements(params?: any): IThunkAction<Promise<{ updated: boolean; [key: string]: any }>, IState> {
  return async (dispatch, getState) => {
    const serviceName = 'cloud.sofialocks.vasho' //  'com.sofialocks.luckeyManager'
    const formattedParams = {
      serviceName: serviceName,
      ...params,
    };
    try {
      const response = await AgreementsAPI.checkUpdatedAgreements(formattedParams);
      if (response.data) {
        dispatch(AgreementsActions.setAgreementFilter({ field: 'serviceName', value: serviceName }));
        return response.data;
      }
      throw new Error();
    } catch (error) {
      throw new Error(error as string);
    }
  };
}

export function acceptAgreements(acceptAgreementsDTO: AgreementsAPI.IAcceptAgreementsDTO): IThunkAction<Promise<any>, IState> {
  return async (dispatch, getState) => {
    try {
      const response = await AgreementsAPI.acceptAgreements(acceptAgreementsDTO);
      if (response.data) {
        return response.data;
      }
      throw new Error();
    } catch (error) {
      throw new Error(error as string);
    }
  };
}

